/*
 * High bug risk!
 * MISSING DOCUMENTATION !
 * At least add some minimal comments when using unusual features like js-links. What is it used
 * for? Do we really need it (No!)?
 * @TODO replace js-modified links with valid CSS and HTML
 */

document.querySelectorAll('.js-overlay-link').forEach(($link) => {
  const $target = $link.closest(
    `.${$link.getAttribute('data-overlay-target')}`,
  );
  const url = $link.getAttribute('href');
  const target = $link.getAttribute('target') || '_self';
  let down;
  let up;

  $target.addEventListener('click', (e) => {
    e.preventDefault();
  });

  if ($target) {
    $target.addEventListener('mouseover', () => {
      $link.classList.add('active-overlay');
      $target.style.cursor = 'pointer';
    });

    $target.addEventListener('mouseout', () => {
      $link.classList.remove('active-overlay');
      $target.removeAttribute('style');
    });

    // prevent click while user-selection
    $target.addEventListener('mousedown', () => {
      down = new Date();
    });

    $target.addEventListener('mouseup', (e) => {
      e.preventDefault();
      up = new Date();

      if (up - down < 200 && e.button !== 2) {
        window.open(url, target);
      }
    });
  }
});
